<template>
  <div class="order-detail">
    <div class="card">
      <div class="title">
        <left-square-outlined @click="onGoBack" />
        <h4>{{ $t('orderManagement.OrderDetail.viewOrder') }}</h4>
      </div>
      <div class="gray-color box-margin">{{ $t('orderManagement.OrderDetail.orderNumber') }}<span class="number-box">{{
        order_detail?.number }}</span></div>
      <div class="box-margin step-content">
        <count-down v-if="order_detail.status == 1"
                    v-slot="timeObj"
                    class="step-title"
                    :time="timeLeft"
                    @timeout="timeout">
          {{ timeObj.mm }}{{ $t('orderManagement.OrderDetail.munite') }}{{ timeObj.ss
          }}{{ $t('orderManagement.OrderDetail.second') }}
        </count-down>
        <div class="step-title">{{ status_desc }}</div>
        <a-steps :current="current"
                 label-placement="vertical">
          <a-step v-for="(log, index) in statusItem"
                  :key="index"
                  :title="log.title"
                  :description="log.description"></a-step>
        </a-steps>
      </div>
      <a-divider />
      <div class="address-content">
        <div class="address-title">
          <div class="icon"></div>{{ $t('orderManagement.OrderDetail.detail') }}
        </div>
        <a-row>
          <a-col :span="12">
            <a-row>
              <a-col :span="12">
                <span class="address-color">{{ $t('orderManagement.OrderDetail.receiver') }}</span><span
                      class="address-margin">{{
                        order_detail.receiver && order_detail.receiver != 'undefined' && order_detail.receiver != 'null' ?
                          order_detail.receiver :
                          order_detail?.user.username }}</span>
              </a-col>
              <a-col :span="12">
                <span class="address-color">{{ $t('orderManagement.OrderDetail.contactInformation') }}</span><span
                      class="address-margin">{{ order_detail.receiver_phone
                        && order_detail.receiver_phone != 'undefined' && order_detail.receiver_phone != 'null' ?
                        order_detail.receiver_phone : order_detail?.user.mobile
                      }}</span>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="12">
            <span class="address-color">{{ $t('orderManagement.OrderDetail.paymentMethod') }}</span><span
                  class="address-margin">{{ order_detail?.pay_type == 0 ? '支付宝' :
                    '微信'
                  }}</span>
          </a-col>
          <a-col :span="12">
            <span class="address-color">{{ $t('orderManagement.OrderDetail.deliveryAddress') }}</span><span
                  class="address-margin">{{ order_detail?.express_company_id ==
                    17 ? '自提' : order_detail.receive_address
                  }}</span>
          </a-col>
          <a-col :span="12">
            <span class="address-color">{{ $t('orderManagement.OrderDetail.remark') }}</span><span
                  class="address-margin">{{
                    order_detail?.remark || '-'
                  }}</span>
          </a-col>
        </a-row>
      </div>
      <a-divider />
      <div class="express-content">
        <div class="express-title">
          <div class="icon"></div>{{ $t('orderManagement.OrderDetail.logisticsInformation') }}
        </div>
        <FlashbaseOrderAddress :order-info="order_detail"
                               :is-admin="false"
                               @confirm-update-order="timeout"
                               @express-click="expressClick" />
      </div>
      <a-divider />
      <div class="custom-content">
        <div class="custom-title">
          <div class="icon"></div>{{ $t('orderManagement.OrderDetail.productInformation') }}
        </div>
        <div>
          <div ref="hiddenContainer"
               class="hidden"></div>
          <div ref="hiddenContainerPreview"
               class="hidden-preview"></div>
          <a-table :columns="columns"
                   :data-source="itemsData"
                   :pagination="false">
            <template #bodyCell="{ column, record }">
              <template v-if="column.dataIndex === 'spu'">
                <div class="flex-box">
                  <div>
                    <div v-if="record.is_custom"
                         class="viewer">
                      <CustomizedImagePreview :customized-data="mergeCustomAreaData(record)" />
                      <!-- <ImageCustomizeViewer :id="record.id + ''"
                                            mode="view"
                                            :container="hiddenContainer"
                                            :template-basic-parameters="templateBasicParameters(renderImageBaseUrl(record), colorOfItem(record)?.value!, record.spu_custom_width, record.spu_custom_height)"
                                            :custom-area="assignCustomizedData(record.spu_custom_areas, record.spu_custom_width, record.customSpu.customizedImages[theFirstCustomizedArea(record)].customized_areas.customable_image_scale, record.customSpu.customizedImages[theFirstCustomizedArea(record)].customized_areas.boundingRect)"
                                            :customized-image="renderImgCustomUrl(record)" /> -->
                    </div>
                    <img v-else
                         :src="toUrl(record.image)"
                         class="viewer" />

                  </div>
                  <div class="item-flex">
                    <div>{{ record.spu_name || "" }}</div>
                    <div class="item-attr">
                      <span v-for="(attr, index) in convertAttrs(record.sku_attrs)"
                            :key="index">
                        {{ attr.name }}:
                        <span class="attr_color">
                          {{ attr.value }}
                        </span>
                      </span>
                    </div>
                  </div>
                  <a-button v-show="record.is_custom"
                            @click="onShowDetail(record)">{{ $t('orderManagement.OrderDetail.printingDetails')
                            }}</a-button>

                </div>
              </template>
              <template v-if="column.dataIndex === 'clothPrice'">
                <div>
                  <span v-if="record.price_detail">
                    ￥{{ calcPrice.calcSinglePrice(record.price_detail, true) }}
                  </span>
                  <span v-else>-</span>
                </div>
              </template>
              <template v-if="column.dataIndex === 'customPrice'">
                <div v-if="record.is_custom">
                  <div v-if="record.price_detail">
                    ￥{{ calcPrice.calcCustomPrice(record.price_detail, true).customAreaPrice }}
                  </div>
                  <div v-if="record.price_detail">
                    <span v-for="item of record.price_detail.custom_price"
                          :key="item.id"
                          class="custom-details-areas">
                      <div>{{ item.name }}: {{ exactDecimal(priceTimes((item.technology?.price ||
                        item.price).toString(),
                        priceScale(item))) }}</div>
                      <div v-if="item.dss_image_price && item.dss_image_price != '0'">
                        <span>{{ $t('orderManagement.OrderDetail.designDrawing') }}：{{ item.dss_image_price }}</span>
                        <a-tooltip>
                          <template #title>{{ $t('orderManagement.OrderDetail.designDrawingMsg') }}</template>
                          <question-circle-outlined class="icon-margin" />
                        </a-tooltip>
                      </div>

                    </span>
                  </div>
                </div>
                <div v-else>-</div>
              </template>
              <template v-if="column.dataIndex === 'price'">
                <div v-if="record.price_detail"
                     style="color: #DE4A09;">
                  ￥{{ calcPrice.calcTotalPrice(record.price_detail, record.quality || 1, true) }}
                </div>
                <div v-else>-</div>
              </template>
              <template v-if="column.dataIndex === 'technology'">
                <div v-if="record.price_detail.custom_price.length"
                     class="technology-name">
                  <span v-for="item in record.price_detail.custom_price">{{ item.name[0] + ' : ' }}{{
                    item.technology?.name || $t('orderManagement.OrderDetail.printing') }}</span>
                </div>
                <div v-else>
                  -
                </div>
              </template>
              <template v-if="column.dataIndex === 'item_status'">
                <div v-if="record.item_status == 0">
                  <div v-for="item in statusType"
                       :key="item.value"><span v-if="item.value == order_detail?.status">{{ item.label }}</span></div>
                </div>
                <div v-else-if="record.item_status == 1">
                  {{ $t('orderManagement.OrderDetail.reunding') }}
                </div>
                <div v-else-if="record.item_status == 2">
                  {{ $t('orderManagement.OrderDetail.reunded') }}
                </div>
              </template>
              <template v-if="column.dataIndex === 'operation'">
                <a-tooltip placement="bottom"
                           :color="'#111'">
                  <template #title>
                    <span>{{ $t('orderManagement.OrderDetail.comment') }}</span>
                  </template>
                  <comment-outlined v-if="order_detail.status == 6 && !record.is_comment"
                                    class="operation-icon"
                                    @click="goToComment(record)" />
                </a-tooltip>
                <a-tooltip placement="bottom"
                           :color="'#111'">
                  <template #title>
                    <span>{{ order_detail.refunds.length > 0 ? $t('orderManagement.OrderDetail.viewAfterSales') :
                      $t('orderManagement.OrderDetail.applyAfterSales') }}</span>
                  </template>
                  <customer-service-outlined v-if="![1, 2, 7, 8].includes(order_detail.status)"
                                             class="operation-icon"
                                             @click="afterSaleClick(record)" />
                </a-tooltip>
              </template>
            </template>
          </a-table>
        </div>
        <div class="price-detail">
          <div class="price-money price-flex">
            <span class="price-subtitle">{{ $t('orderManagement.OrderDetail.totalAmount') }}</span>
            <span>￥{{ new
              BigNumber(order_detail.pay_amount).minus(order_detail.express_fee || 0).plus(order_detail.discount_amount
                ||
                0).toNumber().toFixed(2)
              }}</span>
          </div>
          <div class="price-money price-flex">
            <span class="price-subtitle">{{ $t('orderManagement.OrderDetail.freight') }}</span>
            <span>￥{{ new BigNumber(order_detail.express_fee).toFixed(2) }}</span>
          </div>
          <div class="price-money price-flex">
            <span class="price-subtitle">{{ $t('orderManagement.OrderDetail.couponDeduction') }}</span>
            <span>-￥{{ order_detail.discount_amount ? new BigNumber(order_detail.discount_amount).toFixed(2) : 0
              }}</span>
          </div>
          <div v-if="order_detail.refunds.length > 0 && order_detail.refunds[0].refund_status == 2"
               class="price-money price-flex">
            <span class="price-title">{{ $t('orderManagement.OrderDetail.afterSalesRefund') }}</span>
            <span class="price-color">￥{{ order_detail.refunds[0].refund_amount }}</span>
          </div>
          <div class="price-money price-flex">
            <span class="price-title">{{ $t('orderManagement.OrderDetail.actualPayment') }}</span>
            <a-popover v-if="order_detail.sale"
                       placement="top">
              <span class="price-color">￥{{
                order_detail.adjustPrice ? order_detail.adjustPrice.pay_amount : order_detail.pay_amount }}</span>
              <template #content>
                <FlashbaseAdjustDetail :sale-data="order_detail.sale"
                                       :adjust-data="order_detail.adjustPrice"
                                       :is-order="true"
                                       :is-adjust="order_detail.adjustPrice"
                                       :is-sale="order_detail.sale"></FlashbaseAdjustDetail>
              </template>
            </a-popover>
            <div v-else>
              <span class="price-color">￥{{ order_detail.pay_amount }}</span>
            </div>
          </div>
          <div v-if="order_detail.refunds.length > 0 && order_detail.refunds[0].refund_status == 2"
               class="price-money price-flex">
            <span class="price-title">{{ $t('orderManagement.OrderDetail.afterSalesActualPayment') }}</span>
            <span class="price-color">￥{{ new
              BigNumber(order_detail.pay_amount).minus(order_detail?.refunds[0].refund_amount || 0).toFixed(2) }}</span>
          </div>
        </div>
      </div>
    </div>
    <FlashbaseAfterSale :data="afterSaleContent"
                        :visible="afterVisible"
                        :is-admin="false"
                        :after-type="afterType"
                        @after-change="afterChange"></FlashbaseAfterSale>
    <express :visible="expressVisible"
             :row-data="rowData"
             :receive-address="receive_address"
             @visible-change="visibleChange"></express>
    <a-modal v-model:visible="popVisible"
             width="700px"
             :title="$t('orderManagement.OrderDetail.printingDetails')"
             :destroy-on-close="true"
             @ok="closeModal"
             @cancel="closeModal">
      <div style="display:flex;align-items: center;flex-direction: column;justify-content: space-between;">
        <div style="display:flex;"
             class="custom-box">
          <div v-for="(item, index) in thumbnails"
               :key="index"
               class="viewer-preview">
            <ImageCustomizeViewer :id="`Order-${item.id}-${index}`"
                                  :ref="createEditorRef"
                                  mode="view"
                                  :name="item.name"
                                  :container="hiddenContainerPreview"
                                  :template-basic-parameters="templateBasicParameters(toUrl(findCustomableImage(selectColor!, item))!, selectColor?.value!, item.width, item.height)"
                                  :custom-area="assignOriginalCustomizedData(item)"
                                  :customized-image="toUrl(item.customized_image)" />
          </div>
        </div>
        <div style="display: flex;width: 100%;justify-content: space-around;">
          <a-button v-if="thumbnails.length > 0"
                    @click="download">{{ $t('orderManagement.OrderDetail.download')
            }}</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref, computed } from "vue"
import { useRoute, useRouter } from "vue-router"
import { toUrl } from "@/utils"
import JSZip from 'jszip'
import Express from "../components/Express.vue"
import { saveAs } from 'file-saver'
import { ImageCustomizeEditor as ImageCustomizeViewer, CustomizedImagePreview } from '@iota-cn/ui-components'
import { type OrderDetails, convertColor } from "../../config"
import { getOrderDetail, fetchCustomSpu, queryExpress, fetchOrderStatus } from "../../api/index"
import { assignCustomizedData, convertToCustomizedImage, findCustomableImage, assignOriginalCustomizedData, templateBasicParameters } from '../../../custom-spus/utils'
import countDown from './CountDown.vue'
import { message } from 'ant-design-vue'
import BigNumber from "bignumber.js"
import dayjs from "dayjs"
import { DefaultCalcPriceHelper } from "@flashbase/util-coupon"
import { useI18n } from "vue-i18n"
const { t } = useI18n()
const calcPrice = new DefaultCalcPriceHelper()
const route = useRoute()
const router = useRouter()
type FabricElement = InstanceType<typeof ImageCustomizeViewer>
const order_detail = ref<OrderDetails>({
  id: 0,
  number: '',
  pay_amount: 0,
  out_trade_number: '',
  receive_address: '',
  express_number: 0,
  remark: '',
  status: 0,
  items: [],
  pay_type: 0,
  express_company_id: 0,
  receiver: '',
  receiver_phone: '',
  createdAt: '',
  pay_at: '',
  deliver_at: '',
  express_fee: '',
  selectCoupon: [],
  discount_amount: 0,
  refunds: [],
  deliver: [],
  user: {},
  sale: {},
  adjustPrice: {},
  is_sale: false,
  is_external: false,
  is_design_order: false,
})
const timeLeft = ref()
const itemsData = ref<any[]>()
const status_desc = ref<string>()
const statusType = ref<any[]>([])
onMounted(async () => {
  const id = route.params.id
  await init(id)
  if (order_detail.value.status == 1) {
    const now = dayjs().unix()
    const createdTime = dayjs(order_detail.value.createdAt).unix()
    timeLeft.value = new BigNumber(900).minus((new BigNumber(now).minus(createdTime))).toNumber()
  }
  statusType.value = []
  await fetchOrderStatus().then((res) => {
    res.data.items.forEach((item: any) => {
      statusType.value.push({
        value: item.key,
        label: item.name
      })
    })
  })
})
const timeout = () => {
  const id = route.params.id
  init(id)
}

const mergeCustomAreaData = (item: any) => {
  return Object.assign(
    {},
    {
      image: renderImageBaseUrl(item),
      customArea: Object.assign(
        item.customSpu?.customizedImages[theFirstCustomizedArea(item)]?.customableImage?.custom_areas ||
        item.customSpu?.customizedImages[theFirstCustomizedArea(item)]?.spu_custom_areas
        || {},
        { boundingRect: item.customSpu?.customizedImages[theFirstCustomizedArea(item)]?.customized_areas.boundingRect }
      ),
      customizedImage: item.image + `?x-oss-process=image/resize,w_50/quality,q_90` || "",
      width: 1000,
      height: 1000,
      cssWidth: 50,
      cssHeight: 50,
    },
  )
}

const init = async (id: any) => {
  await getOrderDetail(id).then((res: any) => {
    // orderadress组件监听了id
    order_detail.value.id = 0
    order_detail.value = res
    itemsData.value = res.items
    order_detail.value.receive_address = res.receiver_province + res.receiver_city + res.receiver_district + res.receiver_street + res.receive_address
    statusItem.value = [
      {
        title: t('orderManagement.OrderDetail.ordered'),
        description: order_detail.value?.createdAt ? dayjs(order_detail.value?.createdAt).format("YYYY-MM-DD HH:mm:ss") : '',
      },
      {
        title: t('orderManagement.OrderDetail.paid'),
        description: order_detail.value?.pay_at ? dayjs(order_detail.value?.pay_at).format("YYYY-MM-DD HH:mm:ss") : '',
      },
      {
        title: t('orderManagement.OrderDetail.produced'),
        description: '',
      },
      {
        title: t('orderManagement.OrderDetail.shipped'),
        description: order_detail.value?.deliver_at ? dayjs(order_detail.value?.deliver_at).format("YYYY-MM-DD HH:mm:ss") : '',
      },
      {
        title: t('orderManagement.OrderDetail.received'),
        description: '',
      },
    ]
    switch (order_detail.value?.status) {
      case 1:
        current.value = 0
        status_desc.value = t('orderManagement.OrderDetail.productOrdered')
        break
      case 2:
        current.value = 1
        status_desc.value = t('orderManagement.OrderDetail.productPaid')
        break
      case 3:
        current.value = 1
        status_desc.value = t('orderManagement.OrderDetail.productInProduction')
        break
      case 4:
        current.value = 2
        status_desc.value = t('orderManagement.OrderDetail.productProduced')
        break
      case 5:
        current.value = 3
        status_desc.value = t('orderManagement.OrderDetail.productShipped')
        break
      case 6:
        current.value = 4
        status_desc.value = t('orderManagement.OrderDetail.productReceived')
        break
      case 7:
        current.value = 1
        status_desc.value = t('orderManagement.OrderDetail.productRefunding')
        break
      case 8:
        current.value = -1
        status_desc.value = t('orderManagement.OrderDetail.orderCancelled')
        break
    }
  })
}
const current = ref<number>(3)
const statusItem = ref()
const columns = computed(() => [
  {
    title: t('orderManagement.OrderDetail.received'),
    dataIndex: 'spu',
    align: 'center',
    width: "25%",
  },
  {
    title: t('orderManagement.OrderDetail.technology'),
    dataIndex: 'technology',
    align: 'center',
    width: "10%",
  },
  {
    title: t('orderManagement.OrderDetail.quantity'),
    dataIndex: 'quality',
    align: 'center',
    width: "7%",
  },
  {
    title: t('orderManagement.OrderDetail.clothUnitPrice'),
    dataIndex: 'clothPrice',
    align: 'center',
    width: "10%",
  },
  {
    title: t('orderManagement.OrderDetail.printingUnitPrice'),
    dataIndex: 'customPrice',
    align: 'center',
    width: "10%",
  },
  {
    title: t('orderManagement.OrderDetail.amount'),
    dataIndex: 'price',
    align: 'center',
    width: "7%",
  },
  {
    title: t('orderManagement.OrderDetail.productStatus'),
    dataIndex: 'item_status',
    align: 'center',
    width: "6%",
  },
  {
    title: t('orderManagement.OrderDetail.operation'),
    dataIndex: 'operation',
    align: 'center',
    width: "10%",
  },
])
const onGoBack = () => {
  router.push({ name: 'orderManagement', params: { from: 'detail' } })
}
const expressVisible = ref<boolean>(false)
const rowData = ref<any[]>([])
const receive_address = ref<string>('')
// 快递信息
const expressClick = async (record: any) => {
  if (record.status < 5 || !record.express_company_id || record.express_number == '-') {
    return
  }
  rowData.value = []
  receive_address.value = record.receive_address
  const data = {
    express_number: record.express_number,
    receiver_phone: record.receiver_phone,
    express_company_id: record.express_company_id
  }
  await queryExpress(data).then((res: any) => {
    rowData.value = res.logistics
    if (rowData.value.length > 0) {
      rowData.value[0].status = 'finish'
      expressVisible.value = true
    } else {
      message.warning(t('orderManagement.OrderDetail.warningMsg'))
    }

  }).catch(err => {
    message.error(err.message)
  })
}
const visibleChange = (visible: any) => {
  expressVisible.value = visible
}
const hiddenContainer = ref()
const hiddenContainerPreview = ref()
const colorOfItem = (item: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const colorAttr = item.sku_attrs?.find((a: any) => {
    return a.attribute.key === 'color'
  })
  if (colorAttr) {
    return convertColor(colorAttr.value || colorAttr.object_value)
  }
  return undefined
}

const renderImageBaseUrl = (record: any) => {
  const baseHeightRatio = Math.round(record.spu_custom_height * (200 / record.spu_custom_width))
  return toUrl(record.spu_customable_image) + `?x-oss-process=image/resize,h_${baseHeightRatio},m_lfit`
}

const renderImgCustomUrl = (record: any) => {
  if (!record.customSpu)
    return

  const customizedAreas = record.customSpu.customizedImages[theFirstCustomizedArea(record)].customized_areas
  const scaleRatio = customizedAreas.customable_image_scale || record.customSpu.customizedImages[theFirstCustomizedArea(record)].customableImage.custom_areas.scale
  // const heightRatio = Math.round((customizedAreas.boundingRect?.height || record.spu_custom_areas.height) * (200 / record.spu_custom_width) * scaleRatio)
  const widthRatio = Math.round((customizedAreas.boundingRect?.width || record.spu_custom_areas.width) * (200 / record.spu_custom_width) * scaleRatio)
  const renderCustomUrl = toUrl(record.image) + `?x-oss-process=image/resize,w_${widthRatio}/quality,q_90`
  return renderCustomUrl
}

const convertAttrs = (attrs: any[]) => {
  const arr = [] as any
  attrs.forEach((a) => {
    const data = {
      name: '',
      value: ''
    }
    data.name = a.attribute.name
    data.value = a.object_value ? a.object_value.name : a.value
    arr.push(data)
  })
  arr.sort(sortBy('name', false))
  return arr
}
const sortBy = (attr: any, rev: any) => {
  // 第二个参数没有传递 默认升序排列
  if (rev == undefined) {
    rev = 1
  } else {
    rev = (rev) ? 1 : -1
  }

  return function (a: any, b: any) {
    a = a[attr]
    b = b[attr]
    if (a < b) {
      return rev * -1
    }
    if (a > b) {
      return rev * 1
    }
    return 0
  }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const allImageEditors: any = {}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createEditorRef = computed(() => (value: any) => {
  if (value) {
    const id = value.editorId()
    allImageEditors[id] = value
  }
})
const customSpu = ref<any>()
const thumbnails = ref<any[]>([])
const popVisible = ref<boolean>(false)
const selectColor = ref<any>()
const onShowDetail = async (item: any) => {
  customSpu.value = []
  await fetchCustomSpu(item.custom_spu_id).then((res: any) => {
    selectColor.value = colorOfItem(item)
    customSpu.value = res
    createCustomImages()
    popVisible.value = true
  }).catch(() => {
    message.error(t('orderManagement.OrderDetail.errorMsg1'))
  })
}
const closeModal = () => {
  customSpu.value = []
  popVisible.value = false
}
const createCustomImages = () => {
  thumbnails.value = []
  customSpu.value?.customizedImages.forEach((i: any) => {
    const customizedImage = convertToCustomizedImage(i)
    if (customSpu.value.external_base_data) {
      thumbnails.value.push(Object.assign({}, customizedImage, {
        custom_areas: i.custom_areas,
        image: i.spu_customable_image,
        width: i.custom_areas.templateWidth, height: i.custom_areas.templateHeight
      }))
    } else {
      thumbnails.value.push(customizedImage)
    }
  })
}

// 临时解决方案 接口返回的customizedImages顺序不一致 order排序以后 sql太长不生效 加入 separate: true会丢失custom spu id 导致数据为空 
const theFirstCustomizedArea = (record: any) => {
  if (record.customSpu && record.customSpu.customizedImages && record.customSpu.customizedImages.length)
    return record.customSpu.customizedImages.reduce((minIdx: number, curr: any, idx: number, array: any[]) => {
      return curr.custom_area_id < array[minIdx].custom_area_id ? idx : minIdx
    }, 0)
  else return 0
}
// 批量下载合成图
const download = () => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const images: any = []
    // const customImages: any = {}
    // let count = 0
    const zip = new JSZip()
    let el: any
    Object.keys(allImageEditors).forEach((key) => {
      el = allImageEditors[key] as FabricElement
      const props = el.$props
      // const suffix = '-' + (props.name || '')
      const suffixWithColor = '-' + (props.name || '') + '-' + (props.colorName || '')
      const data = el.exportFullImageAsBlob()
      images.push({
        name: key + suffixWithColor,
        data
      })
      // if (!customImages[el.$props.customizedImage]) {
      //   const index = count
      //   images.push(fetch(el.$props.customizedImage).then((res) =>
      //     res.blob()).then(blob => blobToBase64(blob)).then(base64 => {
      //       return {
      //         name: `Customized-${index}` + suffix,
      //         data: new Blob([el.convertBase64PNGToBinWithDPI(base64, 300)], { type: 'image/png' })
      //       }
      //     }))
      //   customImages[el.$props.customizedImage] = true
      //   count++
      // }
    })
    Promise.all(images).then((img) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      img.forEach((element: any) => {
        zip.file(`${element.name}-${new Date().getTime()}.png`, element.data, {
          base64: true
        })
      })
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, customSpu.value?.name)
      })
    })
  } catch (error) {
    message.error(t('orderManagement.OrderDetail.errorMsg2'))
    console.log(error)
  }
}


const exactDecimal = (value: any) => {
  return new BigNumber(value).toFixed(2)
}

const priceTimes = (price: string | number, discount: string | number) => {
  return new BigNumber(price).times(new BigNumber(discount))
}
const priceScale = (detail: any) => {
  return Number(detail.discount_amount_scale) || 1
}
const goToComment = (record: any) => {
  const id = route.params.id
  router.push({ path: `/console/orders/order_management/comment/${id}`, query: { order_item_id: record.id } },)
}

const afterSaleContent = ref()
const afterVisible = ref(false)
const afterType = ref('add')
const afterSaleClick = (record: any) => {
  afterVisible.value = true
  afterSaleContent.value = order_detail.value
  afterType.value = order_detail.value.status == 9 || order_detail.value.refunds.length > 0 ? 'edit' : 'add'
}
const afterChange = async (visible: any) => {
  afterVisible.value = visible
  const id = route.params.id
  await init(id)
}
</script>
<style scoped lang="less">
.order-detail {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  overflow: auto;

  .technology-name {
    display: flex;
    flex-flow: column;
    justify-content: space-around;
    align-items: center;
  }

  .card {
    height: 100%;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;

    .title {
      display: flex;
      height: 55px;
      padding: 15px 0;
      border-bottom: 1px solid #e9e9e9;
      align-items: center;

      h4 {
        margin: 0 0 0 10px;
      }
    }

    .gray-color {
      color: #999;
    }

    .number-box {
      margin-left: 10px;
      color: #111;
    }

    .box-margin {
      margin: 20px 0;
    }

    .step-content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .step-title {
        margin-bottom: 5px;
        font-weight: bold;
        color: #111;
      }

      .ant-steps {
        width: 50vw;
        margin-top: 20px;

        :deep(.ant-steps-item-description) {
          width: 200px;
          text-align: start;
          color: #111;
        }

        .ant-steps-item-finish {
          :deep(.ant-steps-item-container:hover) {
            .ant-steps-item-title {
              color: #111;
            }

            .ant-steps-item-description {
              color: #111 !important;
            }

            .ant-steps-item-icon {
              border-color: #111 !important;

              .ant-steps-icon {
                color: #fff !important;
              }
            }
          }

          :deep(.ant-steps-item-title) {
            font-size: 14px;
            font-family: 'Microsoft YaHei';
            color: #111;

          }

          :deep(.ant-steps-item-icon) {
            background: #111;
            border-color: #111;

            .ant-steps-icon {
              color: #fff;
            }
          }

          :deep(.ant-steps-item-tail::after) {
            background-color: #111;
          }
        }

        :deep(.ant-steps-item-title) {
          font-size: 14px;
          font-family: 'Microsoft YaHei';
          color: #ccc;
        }

        :deep(.ant-steps-item-tail::after) {
          background-color: #ccc;
        }

        .ant-steps-item-process {
          :deep(.ant-steps-item-container:hover) {
            .ant-steps-item-title {
              color: #111;
            }

            .ant-steps-item-icon {
              border-color: #111 !important;

              .ant-steps-icon {
                color: #FFF !important;
              }
            }
          }

          :deep(.ant-steps-item-title) {
            font-size: 14px;
            font-family: 'Microsoft YaHei';
            color: #111;
          }

          :deep(.ant-steps-item-icon) {
            background: #111;
            border-color: #111;

            .ant-steps-icon {
              color: #fff;
            }
          }
        }

        .ant-steps-item-wait {
          :deep(.ant-steps-item-description) {
            color: #ccc !important;
          }

          :deep(.ant-steps-item-container:hover) {
            .ant-steps-item-title {
              color: #CCC;
            }

            .ant-steps-item-description {
              color: #CCC !important;
            }

            .ant-steps-item-icon {
              border-color: #CCC !important;

              .ant-steps-icon {
                color: #CCC !important;
              }
            }
          }
        }

      }
    }


    .address-content {
      .address-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .icon {
          width: 20px;
          height: 20px;
          background: url('../../images/ic-address.png') center/cover no-repeat;
          margin-right: 5px;
        }


      }

      .ant-col {
        min-height: 40px;
        line-height: 40px;
      }

      .address-color {
        color: #999;
      }

      .address-margin {
        margin-left: 10px;
      }
    }

    .express-content {
      .express-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .icon {
          width: 20px;
          height: 17px;
          background: url('../../images/ic-express.png') center/cover no-repeat;
          margin-right: 5px;
        }
      }

      .ant-col {
        height: 40px;
        line-height: 40px;
      }

      .express-color {
        color: #999;
      }

      .express-margin {
        margin-left: 10px;
      }
    }

    .custom-content {
      .custom-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .icon {
          width: 18px;
          height: 20px;
          background: url('../../images/ic-spu.png') center/cover no-repeat;
          margin-right: 5px;
        }
      }

      .price-detail {
        float: right;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 150px;
        margin-top: 20px;
        margin-bottom: 30px;

        .price-money {
          color: #111;
          line-height: 30px;
          height: 30px;
          font-size: 14px;

          .price-subtitle {
            color: #999999;
          }
        }

        .price-flex {
          display: flex;
          justify-content: space-between;
          width: 150px;
        }

        .price-color {
          color: #DE4A09;
          font-size: 18px;
          font-weight: bold;
        }
      }

      .hidden {
        width: 50px;
        height: 50px;
        position: absolute;
        visibility: hidden;
        display: block;
      }

      .viewer {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 10px;

        @-moz-document url-prefix() {
          :deep(.fabric-div) {
            width: 50px !important;
            height: 50px !important;
          }

          :deep(.canvas-container) {
            width: 50px !important;
            height: 50px !important;
          }

          :deep(.lower-canvas) {
            width: 50px !important;
            height: 50px !important;
          }

          :deep(.upper-canvas) {
            width: 50px !important;
            height: 50px !important;
          }
        }
      }



      .flex-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;

        .item-flex {
          display: flex;
          flex-direction: column;
          margin-left: 10px;
          text-wrap: wrap;
          text-align: start;
          width: 300px;

          .item-attr {
            font-size: 12px;
          }

          .attr_color {
            color: #999;
            margin-right: 5px;
          }
        }

        .item-quality {
          flex: 1;
          text-align: left;
        }

        .pop-show {
          width: 600px;
          height: 350px;
          position: absolute;
          top: -350px;
          left: 100px;
          border: solid 1px #f6f6f6;
          background-color: #fff;

        }
      }



      .custom-details-areas {
        color: #999999;
        font-size: 12px;
        // margin-right: 5px;

        .icon-margin {
          margin-left: 5px;
        }
      }

      .operation-icon {
        font-size: 20px;
        cursor: pointer;
        margin: 0 10px;
        color: #999
      }

      .operation-icon:hover {
        color: #111;
      }
    }
  }
}

.hidden-preview {
  width: 300px;
  height: 300px;
  position: absolute;
  visibility: hidden;
  display: block;
}


.viewer-preview {
  width: 300px;
  height: 320px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  margin: 0 10px;

  .viewer-image {
    width: 300px;
    height: 300px;
  }

  :deep(.ant-btn) {
    font-size: 12px;
    border: 1px solid black;
    color: #111;
  }

  @-moz-document url-prefix() {
    :deep(.fabric-div) {
      width: 300px !important;
      height: 300px !important;
    }

    :deep(.canvas-container) {
      width: 300px !important;
      height: 300px !important;
    }

    :deep(.lower-canvas) {
      width: 300px !important;
      height: 300px !important;
    }

    :deep(.upper-canvas) {
      width: 300px !important;
      height: 300px !important;
    }
  }
}

.custom-box {
  max-width: 600px;
  overflow-x: auto;
}

:deep(.ant-btn) {
  font-size: 12px;
  border: 1px solid black;
  color: #111;
  margin: 10px 0;
}
</style>